import { cva } from "class-variance-authority";

export const dialogVariants = cva(
  "fixed left-[50%] top-[50%] z-[120] grid w-[calc(100%-1.5rem)] sm:w-full translate-x-[-50%] translate-y-[-50%] gap-4 border shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 data-[state=open]:zoom-in-95 data-[state=closed]:zoom-out-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] rounded-4xl",
  {
    variants: {
      design: {
        default: "bg-background border-border",
        glass:
          "bg-white/85 dark:bg-black/50 backdrop-blur-xl border-black/8 dark:border-white/10 shadow-lg dark:shadow-2xl",
      },
      size: {
        default: "max-w-lg",
        sm: "max-w-sm",
        md: "max-w-md",
        lg: "max-w-2xl",
        xl: "max-w-4xl",
        full: "max-w-[95vw] h-[90dvh]",
      },
    },
    defaultVariants: {
      design: "default",
      size: "default",
    },
  },
);
